import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CompanyService } from '../../../../services/company.service';
import { FormControl, Validators } from '@angular/forms';
import { IItem } from '../../models/group-edit-config';
import { Subject, takeUntil } from 'rxjs';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_UK_DATE_FORMATS } from '../../models/nt-company';
import { CustomErrorStateMatcher } from '../../models/custom-error-state';
import moment from 'moment';

@Component({
  selector: 'app-input-edit-date',
  templateUrl: './input-edit-date.component.html',
  styleUrls: ['./input-edit-date.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MAT_UK_DATE_FORMATS }]
})
export class InputEditDateComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() control: FormControl;
    localConfig!: IItem;
    @Input() set config(_c : IItem){
        this.localConfig = _c;
    }
    errorState = new CustomErrorStateMatcher();

    pseudoControl: FormControl;
    pseudoValue: any;
    company: any;
    sub = new Subject();
    required = false;
    inputFocus = false;
    settingValue = false;
    disabled = false;
    
    @ViewChild('datePicker') picker: any;

    constructor(private comp: CompanyService) { }

    ngOnInit(): void {
        this.pseudoControl = new FormControl(this.control.value);
        this.pseudoValue = this.control.value;
        if(this.control.hasValidator(Validators.required)){
            this.required = true;
        }

        this.control.valueChanges.pipe(takeUntil(this.sub))
            .subscribe(v => {
                //console.log(`${this.localConfig.fieldName}: setting pseudo value based on form control change`, v);
                if(this.settingValue){
                    this.settingValue = false;
                }else{
                    if(v){
                        if(v.format){
                            this.pseudoValue = v;
                        }else{
                            this.pseudoValue = moment(v);
                        }
                    }else{
                        if(v === null){
                            this.pseudoValue = null;
                        }
                        console.log('No value passed to form control');
                    }
                }
            });

        this.control.registerOnDisabledChange((isDisabled: boolean) => {
            this.disabled = isDisabled;
        });

        this.control.statusChanges.pipe(takeUntil(this.sub))
            .subscribe(s => {
                console.log(`${this.localConfig.fieldName}: control status changed`, s);
                
            });

        this.disabled = this.control.disabled;

        this.comp.SelectedCompany.pipe(takeUntil(this.sub))
            .subscribe(c => {
                this.company = c;
                this.updateDateBinding();
            });
    }

    ngOnDestroy(): void {
        this.sub.next(false);
        this.sub.complete();
    }

    ngAfterViewInit(): void {
        this.updateDateBinding();
    }

    //(ngModelChange)="valueChanged($event)"

    blur(e: any){
        if(this.inputFocus){
            this.inputFocus = false;
            this.updateValues();
        }
    }

    valueChanged(e: any){
        //console.log(`${this.localConfig.fieldName}: valuechanged event`);
        if(this.inputFocus){
            //Control is currently holding focus
            //console.log(`${this.localConfig.fieldName}: valuechanged event`, "Input has focus - user date entry");
            return;
        }else{
            //console.log(`${this.localConfig.fieldName}: valuechanged event`, "Input is not focussed - picker entry, update values");
            this.updateValues();
        }
        
        
    }

    private updateValues(){
        this.settingValue = true;
        if(this.localConfig.validatorFn){
            //We have a validator function, so execute it
            const validatedDate = this.localConfig.validatorFn(this.pseudoValue);
            //Format output to string 
            const convertedValue = validatedDate.format('YYYY-MM-DD');
            //Form Control is set to formatted value
            this.control.setValue(convertedValue, {emitEvent: false});
            //Local control is set to updated moment value
            this.pseudoValue = validatedDate;
            console.log(`${this.localConfig.fieldName}: updateValues`, "Updated date input value to give new value to form", validatedDate, convertedValue);


            //this.pseudoControl.setValue(validatedDate, {emitEvent: false, onlySelf: true});
            //this.pseudoControl.updateValueAndValidity({onlySelf: true, emitEvent: false});
        }else{
            if(this.pseudoValue){
                if(this.pseudoValue.format){
                    this.control.setValue(this.pseudoValue.format('YYYY-MM-DD'), {emitEvent: false});
                    console.log(`${this.localConfig.fieldName}: updateValues`, "New value passed to form", this.pseudoValue);
                }else{
                    console.log('Pseudeo value has no format function so is probabaly not a moment.');
                }
            }else{
                console.log("No value to pass to form - setting null");
                this.control.setValue(null, {emitEvent: false});
            }
        }

        this.control.updateValueAndValidity();
    }

    updateDateBinding(){
        if(!this.picker){
            console.log("input-edit-date: picker not yet defined");
            return;
        }

        if(!this.company && !this.localConfig.controlDataType){
            console.log("input-edit-date: no company or local config data type to determine date format");
            return;
        }

        const region = this.localConfig.controlDataType ?? this.company?.defaultCurrency;

        if (region.indexOf('USD') > -1 || region.indexOf('CAD') > -1) {
            console.log('input-edit-date has seen company requires US date format');
            const d = this.picker.datepickerInput._dateFormats;
            d.parse.dateInput = 'MM/DD/YYYY';
            d.display.dateInput = 'MM/DD/YYYY';
            this.picker.datepickerInput._dateFormats = d;
        }else{
            console.log('input-edit-date has seen company does not require US date format');
            const d = this.picker.datepickerInput._dateFormats;
            d.parse.dateInput = 'DD/MM/YYYY';
            d.display.dateInput = 'DD/MM/YYYY';
            this.picker.datepickerInput._dateFormats = d;
        }
    }

}
